import { render } from "./ListagemOS.vue?vue&type=template&id=4e984817"
import script from "./ListagemOS.vue?vue&type=script&lang=js"
export * from "./ListagemOS.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__